@if (journey) {
  <div>
    <p class="mb-3.5 text-[11px] font-semibold uppercase tracking-[0.13em] text-gray-400 dark:text-gray-500">Your journey</p>

    <div class="grid" [style.grid-template-columns]="gridTemplateColumns">
      @for (step of steps; track step.key; let i = $index) {
        <button
          type="button"
          (click)="select(i)"
          [attr.aria-current]="i === journey.current_step ? 'step' : null"
          class="relative flex cursor-pointer flex-col items-center bg-transparent px-1 text-center focus:outline-none">
          <!-- Connector to the previous step -->
          @if (i > 0) {
            <span
              class="absolute left-[-50%] top-4 h-[3px] w-full"
              [ngClass]="{
                'bg-green-500': step.state === 'done',
                'bg-brand-500': step.state === 'current',
                'bg-gray-200 dark:bg-gray-700': step.state === 'upcoming'
              }"
              aria-hidden="true"></span>
          }

          <!-- Node -->
          <span
            class="relative z-[1] grid h-9 w-9 place-items-center rounded-full border-[3px] text-sm font-bold transition"
            [ngClass]="{
              'border-green-600 bg-green-600 text-white': step.state === 'done',
              'border-brand-500 bg-white text-brand-700 ring-4 ring-brand-50 dark:bg-gray-900 dark:ring-brand-900/30': step.state === 'current',
              'border-gray-200 bg-white text-gray-400 dark:border-gray-700 dark:bg-gray-900': step.state === 'upcoming'
            }">
            @if (step.state === 'done' && step.key === 'planning') {
              <lucide-icon [name]="StarIcon" size="16"></lucide-icon>
            } @else if (step.state === 'done') {
              <lucide-icon [name]="CheckIcon" size="16"></lucide-icon>
            } @else {
              {{ i + 1 }}
            }
          </span>

          <!-- Label -->
          <span
            class="journey-step-label mt-2 max-w-[7rem] text-xs font-semibold"
            [ngClass]="{
              'text-green-700 dark:text-green-400': step.state === 'done' && step.key === 'planning',
              'text-gray-700 dark:text-gray-200': step.state === 'done' && step.key !== 'planning',
              'text-brand-700 dark:text-brand-300': step.state === 'current',
              'text-gray-400 dark:text-gray-500': step.state === 'upcoming'
            }">
            {{ step.label }}
          </span>

          <!-- TVG-367: amber count tag, internal Sales journey only. -->
          @if (step.count_label) {
            <span
              class="mt-1 whitespace-nowrap rounded-full bg-amber-50 px-2 py-0.5 text-[11px] font-medium text-amber-600 dark:bg-amber-500/15 dark:text-amber-400">
              {{ step.count_label }}
            </span>
          }
        </button>
      }
    </div>

    <!-- Selected-step explanation, with the action when the step carries one. -->
    @if (active) {
      <div class="mt-4 flex flex-col gap-3 border-t border-gray-100 pt-3.5 sm:flex-row sm:items-center sm:justify-between dark:border-gray-800">
        <p class="text-sm text-gray-600 dark:text-gray-300">
          <span class="font-semibold text-gray-900 dark:text-white">{{ active.label }}.</span>
          {{ active.explanation }}
        </p>
        @if (active.cta) {
          <button
            type="button"
            (click)="onAction(active)"
            [disabled]="active.key === 'viewing' && viewingRequested"
            class="inline-flex shrink-0 items-center gap-1.5 self-start rounded-lg bg-brand-500 px-3.5 py-2 text-sm font-semibold text-white shadow-theme-xs transition hover:bg-brand-600 disabled:cursor-not-allowed disabled:bg-green-600 disabled:opacity-100 sm:self-auto">
            {{ active.key === 'viewing' && viewingRequested ? 'Viewing requested' : active.cta }}
          </button>
        }
      </div>
    }
  </div>
}
